<template>
  <div>
    <b-dropdown variant="primary" dropdown>
      <template v-slot:button-content>
        <i class="fas fa-angle-down"></i>
      </template>
      <b-dropdown-item v-b-modal="`modal${companyID}`" :disabled="disabled">
        Ver CIIU asociados
      </b-dropdown-item>

      <b-modal
        :id="`modal${companyID}`"
        centered
        title="Ver CIIU asociados"
        title-class="font-18"
        hide-footer
      >
        <div class="px-2 pt-2 overflow-hidden bg-white" v-if="list.length > 0">
          <table
            class="
              pt-2
              table table-sm table-responsive
              border-bottom
              min-w-full
              divide-y divide-gray-200
              table-striped
              rounded
              col-sm-12
            "
          >
            <thead class="table-active">
              <tr>
                <th
                  scope="col"
                  class="
                    px-6
                    text-left text-xs
                    font-medium
                    text-gray-500
                    align-middle
                    mx-2
                    col-sm-3
                  "
                >
                  Código
                </th>
                <th
                  scope="col"
                  class="
                    px-6
                    text-left text-xs
                    font-medium
                    text-gray-500
                    align-middle
                    mx-2
                    col-sm-9
                  "
                >
                  Nombre
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="ciu in list" :key="ciu.id">
                <td class="px-6 whitespace-nowrap text-sm text-gray-500 mx-2">
                  <b>{{ ciu.code }}</b>
                </td>
                <td class="px-6 whitespace-nowrap text-sm text-gray-500 mx-2">
                  {{ ciu.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="px-2 py-2 overflow-hidden bg-white" v-else>
          <div class="text-center">
            <h5 class="text-gray-500">No hay CIIU asociados</h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            @click="$bvModal.hide(`modal${companyID}`)"
            class="btn btn-primary btn mx-2"
            data-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </b-modal>
    </b-dropdown>
  </div>
</template>

<script>
import CompanySSOAPI from "@/services/sso/company/companySSO.API";

export default {
  props: {
    companyID: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    /**
     * This method is used to get the Company Data from SSO API with their id.
     */
    getCompany() {
      CompanySSOAPI.getCompany(this.companyID)
        .then((response) => {
          let company = response || null;
          this.list = company.ciius || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getCompany();
  },
};
</script>
